module.exports = __webpack_public_path__ + "img/WCS2.9afa8de2.png";